var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82,
    height: 51,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    transform: "matrix(-1 0 0 1 80.125 0.152344)",
    d: "M79.982147 4.6036997C80.124985 2.2258089 78.33947 0.17217609 75.964737 0.010047175C73.590004 -0.15208174 71.572372 1.667365 71.429527 4.0632701L71.340256 5.504416C70.733177 15.376266 62.609085 23.06838 52.806606 23.06838L14.632296 23.06838L24.452627 13.160503C26.131012 11.467157 26.131012 8.7289801 24.452627 7.0536475C22.774244 5.3783154 20.060261 5.3603015 18.399733 7.0536475L1.2587881 24.329384C-0.41959602 26.02273 -0.41959602 28.760908 1.2587881 30.436239L18.399733 47.729992C20.078115 49.423336 22.792099 49.423336 24.452627 47.729992C26.113157 46.036644 26.131012 43.298466 24.452627 41.623135L14.632296 31.715256L52.824463 31.715256C67.162148 31.715256 79.017967 20.474319 79.910721 6.0448456L80 4.6036997L79.982147 4.6036997Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/Path.a4fe5a2fb05f7ccfd72c759c8c2249be.svg";
export { ForwardRef as ReactComponent };